export function formatThousand(val = "") {
  return val
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function parseThousand(val = "") {
  return Number(val.toString().replace(/\./g, "")) || 0;
}


export function formatCurrencyCompact(value) {
  if (!value) return "Rp 0";

  if (value >= 1_000_000_000) {
    return `Rp ${(value / 1_000_000_000).toFixed(1)}B`;
  }

  if (value >= 1_000_000) {
    return `Rp ${(value / 1_000_000).toFixed(1)}M`;
  }

  if (value >= 1_000) {
    return `Rp ${(value / 1_000).toFixed(1)}K`;
  }

  return `Rp ${value}`;
}